var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 429.227,
    y: 195.944,
    transform: "matrix(-0.6921 -0.7218 0.7218 -0.6921 585.3806 676.2224)",
    style: {
      fill: "#8292A3"
    },
    width: 15.384,
    height: 34.629
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.739,
    y: 205.569,
    transform: "matrix(-0.7218 -0.6922 0.6922 -0.7218 -18.3847 419.1335)",
    style: {
      fill: "#8292A3"
    },
    width: 34.631,
    height: 15.385
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B2A32"
    },
    d: "M121.456,389.971v30.758c0,14.379-11.651,26.03-26.02,26.03H76.719 c-14.369,0-26.02-11.651-26.02-26.03v-40.963"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B2A32"
    },
    d: "M461.303,379.766v40.963c0,14.379-11.651,26.03-26.02,26.03h-18.717 c-14.369,0-26.02-11.651-26.02-26.03v-30.758"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B2A32"
    },
    d: "M150.665,392.925c0,0,0.01,0,0.01,0.01c23.528,17.62,55.291,30.327,105.32,30.327 s81.793-12.707,105.331-30.327c0-0.01,0.01-0.01,0.01-0.01"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2171C"
    },
    d: "M489.867,290.651v46.071l-14.656,25.425l-219.984,19.999l-141.76-14.297l-41.301-4.164 l-50.029-26.963v-46.071c0-36.132,29.292-65.414,65.414-65.414l7.159-33.835l10.728-50.727 c9.302-43.968,48.112-75.434,93.054-75.434h115.012c44.953,0,83.762,31.466,93.054,75.434l17.897,84.562 c18.061,0,34.42,7.323,46.255,19.158C482.544,256.231,489.867,272.579,489.867,290.651z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD121D"
    },
    d: "M111.938,351.644c5.661,6.031,5.661,11.415,1.528,16.205l-41.301-4.164l-50.029-26.963v-46.071 c0-36.132,29.292-65.414,65.414-65.414c19.825,0,33.599,8.01,44.645,20.123C95.241,245.359,73.201,310.353,111.938,351.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD121D"
    },
    d: "M188.234,332.188c-23.958-26.02-35.086-63.824-56.04-86.829 c-11.046-12.113-24.82-20.123-44.645-20.123l6.697-31.671c36.235-7.631,72.983-12.656,109.905-15.066 C168.326,183.371,156.183,269.133,188.234,332.188z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0EAF9"
    },
    d: "M417.766,193.658c-2.379-0.503-4.759-0.995-7.149-1.467 c-101.761-20.492-207.441-20.523-309.223-0.092c-2.39,0.472-4.769,0.964-7.149,1.467l11.189-52.891 c9.302-43.968,48.112-75.434,93.054-75.434h115.012c44.942,0,83.762,31.466,93.054,75.434L417.766,193.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D9F2"
    },
    d: "M410.618,192.192c-101.761-20.492-207.441-20.523-309.223-0.092l4.041-19.117 c9.302-43.968,48.112-75.434,93.054-75.434h115.012c44.942,0,83.762,31.466,93.054,75.434L410.618,192.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AA7B8"
    },
    d: "M497.495,372.843c-159.303,33.019-323.689,33.019-482.991,0c-9.966-2.066-16.28-11.936-14.059-21.869 c0.027-0.12,0.053-0.24,0.081-0.36c2.184-9.768,11.81-15.925,21.611-13.894c154.271,31.955,313.457,31.955,467.728,0 c9.801-2.03,19.427,4.126,21.611,13.894l0.081,0.36C513.775,360.907,507.461,370.778,497.495,372.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8292A3"
    },
    d: "M99.066,386.839c-28.286-3.764-56.46-8.554-84.48-14.359c-9.969-2.061-16.276-11.938-14.061-21.866 c0.031-0.123,0.051-0.246,0.082-0.359c2.185-9.774,11.805-15.928,21.61-13.897c25.21,5.22,50.553,9.59,75.988,13.107 c-4.113,2.892-7.241,7.641-8.379,13.528c-0.021,0.133-0.051,0.277-0.072,0.41C87.907,372.983,91.938,382.501,99.066,386.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD121D"
    },
    d: "M313.506,80.63c18.221,0,36.051,6.319,50.206,17.792c14.155,11.474,24.027,27.611,27.798,45.437 l14.408,68.107c-13.461,3.249-25.268,10.265-35.76,21.194c-12.252,12.762-21.203,29.382-29.857,45.454 c-9.151,16.992-18.613,34.564-31.691,47.068c-13.988,13.374-30.707,19.603-52.613,19.603c-23.729,0-41.666-7.474-56.445-23.517 c-11.117-12.073-19.627-27.878-27.859-43.163c-8.243-15.306-16.766-31.133-28.132-43.611c-10.92-11.974-23.289-19.592-37.48-23.022 l14.408-68.112c3.771-17.826,13.643-33.963,27.798-45.437c14.154-11.474,31.985-17.792,50.206-17.792H256h21.541L313.506,80.63  M313.506,65.246h-35.965H256h-57.506c-44.943,0-83.754,31.459-93.055,75.43l-17.888,84.559l-0.002,0.003 c19.825,0,33.599,8.01,44.645,20.123c20.953,23.005,32.081,60.809,56.04,86.829c15.343,16.656,35.948,28.481,67.762,28.481 c107.7,0,86.921-135.432,168.457-135.432l-0.005-0.003l0,0l-17.888-84.559C397.259,96.705,358.45,65.246,313.506,65.246 L313.506,65.246z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 95.238,
    cy: 291.388,
    r: 32.305
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M82.766,291.383c0-14.382,9.401-26.563,22.391-30.749c-3.125-1.007-6.454-1.557-9.915-1.557 c-17.842,0-32.305,14.463-32.305,32.305s14.463,32.306,32.305,32.306c3.459,0,6.79-0.55,9.915-1.557 C92.166,317.946,82.766,305.765,82.766,291.383z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 413.681,
    cy: 291.388,
    r: 32.305
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD121D"
    },
    d: "M228.733,330.243c-4.38,0-8.736-1.334-12.471-3.964c-15.142-10.66-25.2-27.991-37.757-51.309 c-8.899-16.527-18.102-33.616-31.08-47.135l-0.12-0.125c-3.289-3.42-4.361-8.334-2.794-12.821 c1.568-4.487,5.469-7.665,10.178-8.294c29.022-3.874,58.609-6.095,87.939-6.603c2.08-0.034,4.054,0.759,5.525,2.205 c1.472,1.446,2.3,3.422,2.3,5.486v100.836c0,8.138-4.489,15.523-11.716,19.273C235.578,329.432,232.147,330.243,228.733,330.243z  M162.157,221.139c12.471,14.183,21.315,30.608,29.894,46.538c11.548,21.448,20.68,37.303,33.068,46.023 c2.826,1.99,5.512,0.968,6.535,0.437c1.028-0.533,3.417-2.148,3.417-5.618V215.55C210.73,216.227,186.263,218.103,162.157,221.139z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD121D"
    },
    d: "M283.265,330.281c-3.421,0-6.857-0.813-10.023-2.459c-7.214-3.752-11.696-11.132-11.696-19.261 V207.688c0-2.064,0.83-4.041,2.301-5.487c1.472-1.446,3.45-2.233,5.527-2.204c29.336,0.521,58.928,2.758,87.954,6.648 c4.709,0.631,8.608,3.81,10.174,8.296c1.566,4.485,0.494,9.399-2.797,12.823c-13.045,13.587-22.247,30.675-31.146,47.2 c-12.58,23.36-22.656,40.717-37.84,51.37C291.987,328.952,287.637,330.281,283.265,330.281z M276.929,215.558v93.002 c0,3.466,2.384,5.079,3.409,5.612c1.024,0.532,3.711,1.556,6.545-0.432c12.415-8.711,21.561-24.588,33.128-46.066 c8.57-15.913,17.405-32.318,29.851-46.488C325.749,218.136,301.276,216.248,276.929,215.558z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AA7B8"
    },
    d: "M486.426,164.282c-11.696-11.696-30.726-11.695-42.424,0c-11.696,11.696-11.696,30.727,0,42.424 c5.848,5.848,13.53,8.772,21.212,8.772s15.364-2.924,21.212-8.772C498.122,195.009,498.122,175.978,486.426,164.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AA7B8"
    },
    d: "M67.997,164.282c-11.695-11.695-30.725-11.696-42.424,0c-11.696,11.696-11.696,30.727,0,42.424 c5.848,5.848,13.53,8.772,21.212,8.772s15.364-2.924,21.212-8.772C79.693,195.009,79.693,175.978,67.997,164.282z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M401.203,291.383c0-14.382,9.401-26.563,22.391-30.749c-3.125-1.007-6.454-1.557-9.915-1.557 c-17.842,0-32.305,14.463-32.305,32.305s14.463,32.306,32.305,32.306c3.459,0,6.79-0.55,9.915-1.557 C410.604,317.946,401.203,305.765,401.203,291.383z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.af2196d3f03d8b94cc9407f582251d06.svg";
export { ForwardRef as ReactComponent };